import * as React from "react";
import { Component } from "react";
import "./observation.scss";
import Autocomplete from "../autocomplete/Autocomplete";
import StateDropdown from "./StateDropdown";
import { Param } from "../../api/StudyApi";
import { ParamOption, ParamType } from "../../api/GrammarApi";
import arr from "../../util/ArrayDecorator";
import { Modal, ModalHeader } from "reactstrap";
import ModalBody from "reactstrap/lib/ModalBody";
import Moment from "react-moment";
import { AuthManager } from "../auth/AuthContext";
import i18n from "i18next";

interface ObsParamProps {
  param: Param;
  paramType: ParamType;

  onChange?(param: Param): void;

  authManager: AuthManager;
}

interface ObsParamState {
  option: ParamOption;
  historyOpen: boolean;
}

export default class ObsParam extends Component<ObsParamProps, ObsParamState> {
  constructor(props: ObsParamProps) {
    super(props);

    let option;

    if (props.paramType && props.paramType.options) {
      if (props.param && props.param.value) {
        option = arr(props.paramType.options).findFirst((item) => item.code === props.param.value);
      }
    } else {
      console.warn("No ParamType options defined for param", this.props.param);
    }

    this.state = { option: option, historyOpen: false };
  }

  onChangeValue(option?: ParamOption) {
    this.setState({ option });

    const param = this.props.param || { type: this.props.paramType.code };

    param.value = option ? option.code : null;

    if (!param.state) {
      param.state = "proposal";
    }

    if (this.props.onChange) {
      this.props.onChange(param);
    }
  }

  onChangeState(state: string) {
    const param = this.props.param || { type: this.props.paramType.code };

    if (!param.value && this.state.option) {
      param.value = this.state.option.code;
    }

    param.state = state;

    if (this.props.onChange) {
      this.props.onChange(param);
    }
  }

  private toggleHistory() {
    this.setState((prevState) => {
      return {
        historyOpen: !prevState.historyOpen,
      };
    });
  }

  private addValidatedBy() {
    this.props.param.validatedBy.push(this.props.authManager.whoAmI().login);
    this.forceUpdate();
  }

  render() {
    return (
      <div className="obs-param">
        <div className="input-group">
          <div className="btn-group" role="group" aria-label="Basic example">
            <Autocomplete
              onChange={(option) => this.onChangeValue(option)}
              placeholder={this.props.paramType ? this.props.paramType.label : ""}
              items={this.props.paramType ? this.props.paramType.options : []}
              toLabel={(item) => item.label}
              value={this.state.option}
            />

            <StateDropdown
              group={true}
              state={this.props.param ? this.props.param.state : "proposal"}
              onChange={this.onChangeState.bind(this)}
            />

            {this.props.param && this.props.param.history && (
              <button
                className="btn btn-secondary"
                title={i18n.t("obs.paramHistory")}
                onClick={(evt) => this.toggleHistory()}
              >
                <i className="fa fa-book"></i>
              </button>
            )}

            {this.props.param && this.props.param.source && (
              <span title="Source" className="pl-2 small">
                ({this.props.param.source})
              </span>
            )}
          </div>
        </div>

        {this.props.param && (
          <Modal size="lg" isOpen={this.state.historyOpen} backdrop={false}>
            <ModalHeader toggle={() => this.toggleHistory()}>
              {i18n.t("obs.paramHistory")} {this.props.param.type}
            </ModalHeader>
            <ModalBody>
              <div className="py-2">
                {!this.props.param.validatedBy ||
                  (this.props.param.validatedBy.length == 0 && <div>{i18n.t("obs.noValidation")}</div>)}

                {this.props.param.validatedBy && this.props.param.validatedBy.length > 0 && (
                  <>
                    Validations : [
                    {this.props.param.validatedBy.map((vb, idx) => (
                      <span key={idx}>
                        {vb}
                        {idx != this.props.param.validatedBy.length - 1 && <>, </>}
                      </span>
                    ))}
                    ]
                    <button
                      title={i18n.t("obs.addValidation")}
                      className="ml-2 btn btn-outline-secondary"
                      onClick={(evt) => this.addValidatedBy()}
                    >
                      <span className="badge-container" data-count={this.props.param.validatedBy.length}>
                        <i className="fa fa-check" />
                      </span>
                    </button>
                  </>
                )}
              </div>

              <table className="table table-striped">
                <tbody>
                  <tr>
                    <th>{i18n.t("study.date")}</th>
                    <th>{i18n.t("admin.author")}</th>
                    <th>{i18n.t("obs.role")}</th>
                    <th>{i18n.t("task.state")}</th>
                    <th>{i18n.t("obs.value")}</th>
                    <th>WorkflowId</th>
                  </tr>
                  {this.props.param.history &&
                    this.props.param.history.map((item, idx) => (
                      <tr key={idx}>
                        <td>
                          <Moment format="DD/MM/YYYY HH:mm:ss">{item.tsp}</Moment>
                        </td>
                        <td>{item.author}</td>
                        <td>{item.role}</td>
                        <td>{item.state}</td>
                        <td>{item.value}</td>
                        <td>{item.workflowId}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}
